import { connect, ConnectedProps } from 'react-redux';
import { useParams } from 'react-router-dom-v5-compat';

import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { clearApiLog } from 'dashboard/redux/actions/api-log';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import { loadApiLog } from 'dashboard/redux/thunk-actions/api-log';
import DashboardApiLogsShowView from 'dashboard/views/DashboardApiLogsShowView';
import useApiLoader from 'lib/hooks/useApiLoader';
import useOnMountAndUnmount from 'lib/hooks/useOnMountAndUnmount';
import useRedirectOnEnvironmentChange from 'lib/hooks/useRedirectOnEnvironmentChange';
import { isPermissionsError, permissionsErrorMessage } from 'lib/permissions-errors';

type Params = { apiLogId: string };

const DashboardApiLogsShowRoute = (props: PropsFromRedux) => {
  const { apiLogId } = useParams<Params>() as Params; // apiLogId will always be defined
  useOnMountAndUnmount(props.clearApiLog);

  useRedirectOnEnvironmentChange('/dashboard/api-logs');

  const { loading: apiLogLoading } = useApiLoader({
    loader: () => props.loadApiLog(apiLogId),
    deps: [props.loadApiLog, apiLogId, props.showMessage],
    onNetworkError: () => props.showMessage('Failed to load API log.', MessageType.Failure),
    onError: (error) => {
      if (isPermissionsError(error)) {
        props.showMessage(permissionsErrorMessage(error), MessageType.Failure);
      } else {
        props.showMessage('Failed to load API log.', MessageType.Failure);
      }
    },
  });

  if (apiLogLoading && props.apiLog == null) {
    return <LoadingIndicator fullscreen={true} />;
  }

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return <DashboardApiLogsShowView apiLog={props.apiLog} />;
};

const mapStateToProps = (state: RootState) => ({
  apiLog: state.apiLog.apiLog,
});

const mapDispatchToProps = {
  loadApiLog,
  clearApiLog,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardApiLogsShowRoute);
